import { Box, Flex, customStyled, variant } from '@mafc/trolly';

export const OrderSummaryRow = customStyled(Flex)(
  ({ theme: { fontSizes, colors, space } }) => ({
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: space[3],
    fontSize: fontSizes[2],
    color: colors.black,
  }),
  ({ theme }) =>
    variant({
      variants: {
        default: {
          fontWeight: theme.fontWeights[3],
        },
        header: {
          fontWeight: theme.fontWeights[8],
        },
      },
    })
);

export const MinusSign = customStyled(Box)(({ theme: { colors, space } }) => ({
  marginRight: space[1],
  color: colors.black,
}));
